<template>
  <div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <div slot="header">
        <span>根据商品编号生成直链</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="14" :offset="0">
          <el-input type="textarea" :rows="2" v-model="skus" placeholder="多个商品编号用英文逗号','分隔" :maxlength="-1"
            :show-word-limit="false" :autosize="{ minRows: 2, maxRows: 4 }">
          </el-input>
        </el-col>
        <el-col :span="2" :offset="0">
          <el-input-number v-model="buyNum" size="normal" :min="1" :max="99999" :step="1" controls-position="right">
          </el-input-number>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :offset="0" style="text-align: center;margin-top: 15px;">
          <el-button type="primary" size="small" @click="genConfirm">生成</el-button>
        </el-col>
      </el-row>
      


      <div v-for="(item, index) in confirms" :key="index">
        <p style="margin: 15px auto;">{{ item.confirmUrl }} <el-button type="primary" size="mini"
            @click="copy(item.confirmUrl)">复制</el-button>
        </p>
         <p style="margin: 15px auto;">{{ item.skuDetailUrl }} <el-button type="primary" size="mini"
            @click="copy(item.skuDetailUrl)">复制</el-button>
        </p>

        <el-image :src="item.imgStream" style="width: 200px; height: 200px;" fit="fill" :lazy="true"></el-image>
        <el-image :src="item.imgStream2" style="width: 200px; height: 200px;" fit="fill" :lazy="true"></el-image>
        <el-divider direction="horizontal" content-position="center">分隔符</el-divider>
        
      </div>
    </el-card>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <div slot="header">
        <span>转二维码</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="14" :offset="0">
          <el-input type="textarea" :rows="2" v-model="qrCodeContent" placeholder="需要转的内容" :maxlength="-1"
            :show-word-limit="false" :autosize="{ minRows: 2, maxRows: 4 }">
          </el-input>
        </el-col>
        <el-col :span="2" :offset="0">
          <el-button type="primary" size="small" @click="convertQrCode">生成二维码</el-button>
        </el-col>
      </el-row>

      <div v-for="(item, index) in qrCodeImgList" :key="index">
        <!-- <p style="margin: 15px auto;">{{ item.confirmUrl }} <el-button type="primary" size="mini"
            @click="copy(item.confirmUrl)">复制</el-button>
        </p> -->
        <img :src=item.imgStream></img>
      </div>
    </el-card>
  </div>
</template>

<script>
import { genConfirm ,convertQrCode} from "@/api/jdDoubleProduct";
export default {
  data() {
    return {
      skus: undefined,
      buyNum: 1,
      confirms: [],
      qrCodeContent: undefined,
      qrCodeImgList: undefined,
    };
  },
  created() { },
  mounted() { },
  methods: {
    convertQrCode(){
      let obj = {
        qrCodeContent: this.qrCodeContent
      };
      convertQrCode(obj).then((res) => {
        this.qrCodeImgList = res.data;
      });
    },
    genConfirm() {
      let obj = {
        skus: this.skus,
        buyNum: this.buyNum,
        qrCodeContent:undefined,
      };
      genConfirm(obj).then((res) => {
        this.confirms = res.data;
      });
    },
    copy(val) {
      let oInput = document.createElement("input");
      oInput.value = val;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message.success("复制成功!");
    }
  },
};
</script>

<style></style>
